module.exports = __webpack_public_path__ + "static/media/crisis-situations@2x.20ed5235.png";